const ru = {
  substantiate: 'Обосновывать',
  archive: 'Архив',
  where_to: 'Куда',
  year: 'год',
  salary_cert: 'Справка о полученных доходах',
  year_month: 'Год месяц',
  work_salary: 'Заработная плата',
  bonus: 'Премия',
  other_payments: 'Другие выплаты, (за питание и др.)',
  income_tax: 'Льготный подоходный налог',
  other_aumount: 'Подоходный налог',
  alimony: 'Прочие суммы (жил.облигации, удержание по исполнительным листам, алименты и другие)',
  total_payment: 'Итого выплат',
  work_day: 'Рабочий день',
  holiday: 'Праздничный день',
  weekend: 'Выходные дни',
  dashboard_all: 'Всего',
  requiredpdf: 'Принимается только pdf файл!',
  requiredsize: 'Размер файла должен быть меньше 30 МБ!',
  reysters: 'Каталоги(Реестры)',
  IT: 'Информационные технологии: ',
  PM: 'Кадровое администрирование: ',
  tabel_acces_denied: "У вас нет доступа к этому табелному номеру.",
  signer: 'Подписанты',
  acceptable: 'Получатель',
  date: 'Дата',
  uzauto: 'АО «UzAuto Motors»',
  uzauto: 'АО «UzAuto Motors»',
  rememberMe: 'Запомни меня',
  itemsPerPageText: '',
  itemsPerPageAllText: 'Все',
  company_id: 'Организация',
  department_id: 'Подразделения',
  cancel: 'Отмена',
  save: 'Сохранить',
  logout: 'Выйти',
  add: 'Добавить',
  create: 'Создать',
  created: 'Создан',
  changed: "Изменено",
  published: "Объявлено",
  contacts: 'Контакты для обращения',
  edit: 'Редактировать',
  delete: 'Удалить',
  close: 'Закрыть',
  select: 'Выберите',
  required: 'Поля, отмеченные *, обязательны для заполнения!',
  input_required: 'Это поле обязательно для заполнения',
  create_update_operation: 'Успешно сохранено',
  swal_title: 'Вы уверены?',
  swal_text: 'это действие не может быть отменено позже',
  swal_delete: 'Да, Удалить!',
  swal_deleted: 'Ваш файл был удален!',
  swal_error_title: 'Так!',
  swal_error_text: 'Что-то пошло не так!',
  name_uz_latin: 'Название узбекская латынь',
  name_uz_cyril: 'Название узбекская кириллица',
  name_ru: 'Название русский',
  actions: "Действие",
  name: 'Имя',
  description_uz_cyril: 'Описание кириллица',
  description_uz_latin: 'Описание латинский',
  description_ru: 'Описание русс',
  loadingText: 'Загружается',
  noDataText: 'Данные не найдены!',
  created_at: 'Дата создания',
  updated_at: 'Обновлено в',
  created_by: 'Создан:',
  updated_by: 'Обновлено:',
  deleted_at: 'Удалено в',
  code: 'Код',
  filter: 'Фильтр',
  workflow: 'Документооборот',
  organization: 'Организация',
  balance: 'Баланс',
  created_documents: 'Создавать документы',
  approved_documents: 'Утвержденный документ',
  files: 'Файлы',
  has_employee: 'Работник прикреплен',
  start_date: 'С',
  start_date2: 'года',
  end_date: 'До',
  all_documents: 'Все документы',
  uploadFiles: 'Загрузить файлы',
  publish: 'опубликовать',
  expectation: 'Ожидается',
  today: 'Cегодня',
  yesterday: 'Вчерашний день',
  week: 'Неделя',
  oy: 'Месяц',
  all: 'Все',
  pending: 'В процессе',
  resolution_results: 'Исполненые резолюции',
  resolutions: 'Резолюции',
  executor: 'К исполнению',
  expired: 'Истекает срок действия',
  expired_done: 'Истек срок действия',
  done: 'Завершено',
  qrCodeTitle: 'Для проверки правильности указанных в документе данных, отсканируйте QR-код на мобильном телефоне и проверьте его через сайт предприятия.',
  ready_templates: 'Готовые шаблоны',
  document_statistics: 'Статистика документооборота',
  document_chart: 'Диаграмма документооборота',
  look: 'Посмотреть',
  download: 'Скачать',
  more_than: 'Более',
  and_less: 'Менее',
  more_than_s: 'более символов',
  and_less_s: 'менее символов',
  confirm: 'Подтвердить',
  search: 'Поиск',
  searchInText: 'Поиск из текста',
  document_transfer: 'Передача документов',
  it_is_impossible: 'Этого сотрудника нельзя уволить или перевести в другой штат !!!',
  unfinished_documents: 'Имеет незаконченные документы',
  documents_transferred: 'Документы можно передать следующим сотрудникам!',
  documents_transferred_employee: 'Документы могут передаваться в следующие Штаты сотрудника!',
  for_info: 'Для информации',
  input: {
    required: 'Это поле обязательно для заполнения',
    text: 'Ввод текста',
  },
  gender: {
    gender: 'Пол',
    male: 'Мужчина',
    female: 'Женщина',
  },
  message: {
    lsp_report: 'Отчеты ЛСП',
    lsp_index: 'Отчеты по лист согласования платежа',
    document_template: 'Шаблон документа',
    document_types: 'Тип документа',
    signers_group: "Группа подписантов",
    positions: 'Должность',
    noMessage: "Нет сообщений",
    noAlerts: 'Нет оповещений',
    settings: 'Настройки',
    create: 'Создать новый документ',
    createInfo: 'Создать новый справка',
    menu: 'Меню',
    home: 'Главная страница',
    inbox: 'Входящие',
    outbox: 'Исходящие',
    draft: 'Черновики',
    cancel: 'Отмененный',
    sent: 'Посланный',
    logout: 'Выйти',
    myCompany: 'Моя компания',
    profile: 'Профиль',
    tariffScale: 'Тарифная сетка',
    coefficient: 'Надбавка',
    departmentType: 'Тип подразделений',
    personalType: 'Тип персонала',
    positionType: 'Тип должности',
    expenceType: 'Тип расхода',
    requirementType: 'Тип требования',
    ranges: 'Разряд',
    countries: 'Страна',
    regions: 'Район',
    natioanalities: 'Национальность',
    districts: 'Район',
    requirement: 'Требования к должности',
    documents: 'Документы',
    all: 'Все',
    reports: 'Отчеты',
    report: 'Отчет',
    accessDepartment: 'Доступ к отделам',
    accessType: 'Типы доступа',
    requisites: 'Реквизиты АО "UzAuto Motors"',
    currency: 'Валюты',
    currencyHistory: 'История валют',
    notifications: 'Уведомления',
    znz: 'Отчеты ЗНЗ',
    znz_index: 'Отчеты по закупочным процессами',
    firm_blank: 'Фирменная бланка',
  },
  company_requisites: {
    name_uz_latin: 'Название узбекская латынь',
    name_uz_cyril: 'Название узбекская кириллица',
    name_ru: 'Название русский',
    name: 'Наименование',
    address_name_uz_latin: 'Адрес узбекская латынь',
    address_name_uz_cyril: 'Адрес узбекская кириллица',
    address_name_ru: 'Адрес русский',
    address: 'Адрес',
    INN: 'Номер ИНН',
    inn: 'Номер ИНН',
    account: 'Расчетный счет',
    swift: 'SWIFT код',
    oknh: 'ОКНХ код',
    mfo: 'МФО',
    add_requisites: 'Добавить новый реквизит',
    edit: 'Редактировать',
    delete: 'Удалить',
  },
  requestdoc: {
    index: 'Организации, запрашивающие информацию',
    new: 'Создать',
    update: 'Редактировать',
    delete: 'Удалить',
    unioncom: 'В профком',
    bank: 'В банк',
    tmib: 'ТМИБ га',
    tmig: 'К внешней миграции',
    embassy: 'В посольство',
  },
  user: {
    department_name: 'Название подразделение',
    roles: 'Роли',
    index: 'Пользователи',
    dialogHeaderText: 'Пользователи',
    name: 'Имя',
    description_uz_cyril: 'Описание кириллица',
    description_uz_latin: 'Описание латинский',
    description_ru: 'Описание русс',
    loadingText: 'Загружается',
    noDataText: 'Данные не найдены!',
    created_at: 'Дата создания',
    updated_at: 'Обновлено в',
    created_by: 'Создан:',
    updated_by: 'Обновлено:',
    deleted_at: 'Удалено в',
    code: 'Код',
    filter: 'Фильтр',
    workflow: 'Документооборот',
    organization: 'Организация',
    balance: 'Баланс',
    created_documents: 'Создавать документы',
    approved_documents: 'Утвержденный документ',
    files: 'Файлы',
    has_employee: 'Работник прикреплен',
    start_date: 'С',
    start_date2: 'года',
    end_date: 'До',
    all_documents: 'Все документы',
    uploadFiles: 'Загрузить файлы',
    publish: 'опубликовать',
    expectation: 'Ожидается',
    today: 'Cегодня',
    yesterday: 'Вчерашний день',
    week: 'Неделя',
    oy: 'Месяц',
    all: 'Все',
    pending: 'В процессе',
    resolution_results: 'Исполненые резолюции',
    resolutions: 'Резолюции',
    executor: 'К исполнению',
    expired: 'Истекает срок действия',
    expired_done: 'Истек срок действия',
    done: 'Завершено',
    qrCodeTitle: 'Для проверки правильности указанных в документе данных, отсканируйте QR-код на мобильном телефоне и проверьте его через сайт предприятия.',
    ready_templates: 'Готовые шаблоны',
    document_statistics: 'Статистика документооборота',
    document_chart: 'Диаграмма документооборота',
    look: 'Посмотреть',
    download: 'Скачать',
    more_than: 'Более',
    and_less: 'Менее',
    more_than_s: 'более символов',
    and_less_s: 'менее символов',
    confirm: 'Подтвердить',
    search: 'Поиск',
  },
  input: {
    required: 'Это поле обязательно для заполнения',
    text: 'Ввод текста',
  },
  gender: {
    gender: 'Пол',
    male: 'Мужчина',
    female: 'Женщина',
  },
  message: {
    lsp_report: 'Отчеты ЛСП',
    lsp_index: 'Отчеты по лист согласования платежа',
    document_template: 'Шаблон документа',
    document_types: 'Тип документа',
    signers_group: "Группа подписантов",
    positions: 'Должность',
    noMessage: "Нет сообщений",
    noAlerts: 'Нет оповещений',
    settings: 'Настройки',
    create: 'Создать новый документ',
    createInfo: 'Создать новую справку',
    menu: 'Меню',
    home: 'Главная страница',
    inbox: 'Входящие',
    outbox: 'Исходящие',
    draft: 'Черновики',
    cancel: 'Отмененный',
    sent: 'Посланный',
    logout: 'Выйти',
    myCompany: 'Моя компания',
    profile: 'Профиль',
    tariffScale: 'Тарифная сетка',
    coefficient: 'Надбавка',
    departmentType: 'Тип подразделений',
    personalType: 'Тип персонала',
    positionType: 'Тип должности',
    expenceType: 'Тип расхода',
    requirementType: 'Тип требования',
    ranges: 'Разряд',
    countries: 'Страна',
    regions: 'Район',
    natioanalities: 'Национальность',
    districts: 'Район',
    requirement: 'Требования к должности',
    documents: 'Документы',
    all: 'Все',
    reports: 'Отчеты',
    report: 'Отчет',
    accessDepartment: 'Доступ к отделам',
    accessType: 'Типы доступа',
    requisites: 'Реквизиты АО "UzAuto Motors"',
    currency: 'Валюты',
    currencyHistory: 'История валют',
    notifications: 'Уведомления',
    znz: 'Отчеты ЗНЗ',
    znz_index: 'Отчеты по закупочным процессами',
    firm_blank: 'Фирменная бланка',
  },
  company_requisites: {
    name_uz_latin: 'Название узбекская латынь',
    name_uz_cyril: 'Название узбекская кириллица',
    name_ru: 'Название русский',
    name: 'Наименование',
    address_name_uz_latin: 'Адрес узбекская латынь',
    address_name_uz_cyril: 'Адрес узбекская кириллица',
    address_name_ru: 'Адрес русский',
    address: 'Адрес',
    INN: 'Номер ИНН',
    inn: 'Номер ИНН',
    account: 'Расчетный счет',
    swift: 'SWIFT код',
    oknh: 'ОКНХ код',
    mfo: 'МФО',
    add_requisites: 'Добавить новый реквизит',
    edit: 'Редактировать',
    delete: 'Удалить',
  },
  requestdoc: {
    index: 'Организации, запрашивающие информацию',
    new: 'Создать',
    update: 'Редактировать',
    delete: 'Удалить',
    unioncom: 'В профком',
    bank: 'В банк',
    tmib: 'ТМИБ га',
    tmig: 'К внешней миграции',
    embassy: 'В посольство',
  },
  user: {
    department_name: 'Название подразделение',
    roles: 'Роли',
    index: 'Пользователи',
    dialogHeaderText: 'Пользователи',
    name: 'Имя',
    email: 'Электронная почта',
    phone: 'Телефон',
    department_id: 'Подразделения',
    role_id: ' Роль',
    position: 'Должность',
    username: 'Логин',
    newUser: 'Добавить новый пользователь',
    updateUser: 'Редактировать',
    "role-permission": 'Роли -прикрепить разрешение',
    employee: 'Сотрудник',
    employee_id: 'Сотрудник',
    permission: 'Разрешения',
    department_code: 'Код подразделения',
  },
  profile: {
    employee_name: 'Ф.И.О',
    user_name: 'Имя пользователя: ',
    tabel: 'Табелный номер: ',
    born_date: "Дата рождения: ",
    department: "Подразделения: ",
    department_code: 'Код подразделения',
    employee_position: 'Должность: ',
    role: 'Роль: ',
    email: 'Электронная почта: ',
    imzo: 'Получить ЭЦП',
    password: 'Парол',
    stir: 'ИНН',
    given_date: 'Дата выпуска',
    expere_date: 'Срок годности',
    push: 'Прикрепить выделенные электронный ключ в профиль.',
    select_key: 'Выберите ключ',
    incorrect_login: 'Неверный логин или пароль',
    personal_information: 'Персональная информация',
    all_documents: 'Все документы',
    family_status: 'Семейный статус',
    information: 'Информация',
    order_date: 'Дата приказа',
    order_number: 'Номер приказа',
    first_work_date: 'Первый день работы',
    adress: 'Адрес',

  },
  permission: {
    index: 'Разрешения',
    name: 'Название разрешения',
    display_name: 'Показать имя',
    description: 'Описание',
    dialogHeaderText: "Добавить новые разрешения",
    edit: 'Редактировать'

  },
  role: {
    index: 'Роли',
    name: 'Наименование роль',
    display_name: 'Отображаемое имя',
    description: 'Примечание',
    assigned_permissions: 'Назначенные разрешения',
    not_assigned_permissions: 'Не назначенные разрешения',
    dialogHeaderText: 'Назначить разрешения для роль',
    addRole: 'Добавить новую роль',
  },
  department: {
    name: 'Наименование',
    department_type_id: 'Тип подразделения',
    parent_id: 'Основное подразделение',
    director: "Директор",
    company_id: 'Организация',
    dialog: 'Подразделения',
    index: 'Подразделения',
    create: 'Создать новый подразделения',
    company_name: 'Наименование организации',
    department_code: 'Код подразделения',
    department_name: 'Название подразделения',
    departments: 'Подразделения',
    tree: 'Дерево подразделений',
    manager_staff: 'Штат руководителья',
    management: 'Управляющий персонал',
    director: "Директор",
    itr: "Инж-тех-раб.",
    restitr: "Инж-тех-раб. Остальные",
    rab: "Рабочий",
    master: "Мастер",
    accountant: "Учётчик",
    brigadir: "Бригадир",
    worker: "Рабочие",
    internship: "В.т.ч. На стажировке",
    foreigner: "Иностранцы",
    maternity: "Декрет",
    women: "Женщины",
    branch: 'Филиал',
  },
  departments: {
    name: 'Наименование',
    department_type_id: 'Тип подразделения',
    parent_id: 'Основной подразделения',
    director: "Директор",
    company_id: 'Организация',
    dialog: 'Подразделения',
    index: 'Подразделения',
    create: 'Создать новый подразделения',
    company_name: 'Наименование организации',
    department_code: 'Код подразделения',
    department_name: 'Название подразделения',
    departments: 'Подразделения',
    tree: 'Дерево подразделений',
    manager_staff: 'Штат руководителья',

  },
  company: {
    index: 'Организация',
    dialogHeaderText: 'Организация',
    name: 'Наименование организации',
    newOrganization: 'Новая организация',
    updateCompany: 'Изменить организацию',
  },
  staff: {
    hr: 'Кадровое администрирование',
    name_uz_latin: 'Узбекская латынь',
    name_uz_cyril: 'Узбекская кириллица',
    name_ru: 'Русский',
    department_id: 'Подразделения',
    position_id: 'Должность',
    range_id: 'Разряд',
    personal_type_id: 'Тип персонала',
    expence_type_id: 'Тип расхода',
    rate_count: 'Количество ставок',
    personal_count: 'Личный счет',
    order_date: 'Дата приказа',
    order_number: 'Номер приказа',
    begin_date: 'Дата начала',
    end_date: 'Дата завершения',
    editStaff: 'Редактировать',
    newStaff: 'Создать',
    staff: 'Штатное расписание',
    staff_admin: 'Организационный менеджмент',
    index: 'Штатное расписание',
    admin: 'Админ',
    range_code: 'Разряд',
    expence_type: 'Тип расход',
    personal_type: 'Тип персонала',
    employees_count: 'Кол-во сотр.',
    branch_id: 'Филиал',
    requirements: 'Требовании для кандидата',
    instruction_file_path: 'Ссылка для файл интрукции',
    uploadFiles: 'Загрузить файл',
    fileType: 'Тип файла',
    file: 'Файл',
    files: 'Файли',
    objectType: 'Тип объекта',

  },
  documentTypes: {
    list: 'Список',
    name: 'Имя',
    index: 'Тип документа',
    dialogHeaderText: 'Тип документа'
  },
  document: {
    eimzo_info: 'Информация о цифровом подписе',
    add_parent_document: 'Прикрепленные документы',
    children_document: 'Қуйи алоқадор ҳужжатлар',
    add_doer: 'добавить исполнителя',
    document_sending_department: 'Отправитель',
    document_number: 'Номер документа',
    letter_number: 'Почтовый номер',
    create: 'Создать новый документ',
    new_document: 'Новый документ',
    news_document: 'Новые документы',
    parent_emlpoyee: 'Направляющий персонал',
    edit_document: 'Редактировать',
    document_type_id: 'Тип документа',
    document_created_by: 'Создан:',
    created_at: 'Создано на:',
    confirmers: 'Подтверждающим',
    document_receiving_department: 'Подразделения приема документов',
    attachments: 'Вложения',
    title: 'Заглавие',
    document_content: 'Содержание документа',
    short_content: 'Содержание',
    number: "Исходящий номер",
    correspondent: "Корреспондент",
    type: "Тип",
    should_receive_all_departments: 'Должны получить все подразделенияы',
    documents: 'Документы',
    document_type: 'Тип документа',
    document_template: 'Шаблон документа',
    document_date: 'Дата документа',
    department: 'Управления',
    department_send: 'Отправитель',
    department_receiver: 'Получатель',
    index: 'Документы',
    comment: 'Комментарий',
    assignment: 'Назначение',
    content: 'Кароткий описание',
    reject: 'Отказ',
    documentTypes: 'Типы документа',
    documentTemplates: 'Шаблоны',
    action_type: 'Действие',
    signer_sequence: 'Последовательность',
    staff: 'Подразделение, должность',
    signers: 'Подписанты',
    history: 'История документа',
    creator: 'Ответственный',
    description: 'Описание документа',
    assignment: 'Назначение',
    reaction: 'Действие',
    update: 'Обновить',
    resolution: 'Резолюция',
    resolution_create: 'Дата резолюция',
    due_date: 'Срок',
    files: 'Файлы',
    add_file: 'Добавить файл',
    file_name: 'Имя файла',
    full_search: 'Полный поиск',
    accept: 'Одобрено',
    processing: 'в процессе',
    vacancy: 'Вакансия',
    doc_punkts: 'Пункты документа',
    punkt: 'Пункт',
    add_punkt: 'Добавить Пункт',
    resolution_type: "Тип резолюция",
    inboxs: 'Входящие документы',
    outboxs: 'Исходящие документы',
    drafts: 'Черновики документы',
    cancels: 'Отмененный документы',
    inbox: 'Входящие',
    outbox: 'Исходящие',
    draft: 'Черновики',
    canceled: 'Отмененные',
    status: 'Статус документa',
    term: 'Срок (час)',
    add_signer: 'Добавить подписывающего',
    document_name: 'Название документа',
    add_parent: 'Добавление прямых лидеров',
    empty_employee: 'Сотрудник не присоединился',
    empty_document_relation: 'Документ должен быть прикреплен',
    add_employee: 'Добавить сотрудника',
    send: 'Отправить',
    confirmation: 'Подтверждение',
    return_to: 'Возврат к исполнению',
    copy: 'Копия из документа',
    not_set: 'Не задано',
    start_date: 'Дата начала',
    end_date: 'Дата окончания',
    new: 'Новые',
    ok: 'Одобренные',
    cancel: 'Отмененые',
    process: 'в процесс',
    all: 'Все',
    allhr: 'Все',
    alllsp: 'Все',
    allznz: 'Все',
    reaction_status: 'Статус подписания',
    doers: 'Исполнители',
    doer: 'Исполнитель',
    phone: 'Тел',
    pending_action: 'Ожидающее действие',
    total_sum: 'Настоящая сумма'
  },

  home: {
    home: 'Главный',
  },
  tariffScale: {
    index: 'Тарифная сетка',
    dialogHeaderText: 'Тарифная сетка',
    category: 'Категория',
    salary: 'Оклад',
    order_date: 'Дата приказа',
    order_number: 'Номер приказа',
    create: 'Добавить новая тарифная сетка',
    edit: 'Редактировать'
  },
  coefficient: {
    index: 'Надбавка',
    dialogHeaderText: 'Надбавка',
    code: 'Код',
    percent: 'Процент',
    description: 'Описание',
    order_date: 'Дата приказа',
    order_number: 'Номер приказа',
    status: 'Статус',
    begin_date: 'Дата начала',
    end_date: 'Дата окончания',
    create: 'Добавить новый надбавок',
    edit: 'Редактировать',
    type: 'Типы предпочтений',
  },
  departmentTypes: {
    index: 'Тип подразделения',
    dialogHeaderText: 'Тип подразделения',
    create: 'Добавить новый тип подразделения',
    edit: 'Редактировать'
  },
  personalType: {
    index: 'Тип персонала',
    dialogHeaderText: 'Тип персонала',
    create: 'Добавить новый тип персонала',
    edit: 'Редактировать'
  },
  positionType: {
    index: 'Тип должность',
    dialogHeaderText: 'Тип должность',
    code: 'Код',
    create: 'Добавить новый тип должность',
    edit: 'Редактировать'
  },
  position: {
    index: 'Должность',
    updatePosition: 'Редактировать',
    newPosition: 'Добавить новый должность',
  },
  expenceType: {
    index: 'Тип расхода',
    dialogHeaderText: 'Тип расхода',
    create: 'Добавить новый тип расхода',
    edit: 'Редактировать',
  },
  ranges: {
    index: 'Разряды',
    dialogHeaderText: 'Разряд',
    code: 'Код',
    name: 'Название Разряд',
    minfond: 'Минимум фонд',
    maxfond: 'Максимум фонд',
    order_date: 'Дата приказа',
    order_number: 'Номер приказа',
    create: 'Добавить новый диапазон',
    edit: 'Редактировать'
  },
  recruitment: {
    index: 'Прием на работу',
  },
  transfer: {
    index: 'Перевод',
  },
  dismissal: {
    index: 'Увольнение',
  },
  countries: {
    index: 'Страна',
    dialogHeaderText: 'Страна',
    country_code: 'Код страны',

  },
  districts: {
    index: 'Район',
    region_id: 'Область',
    dialogHeaderText: 'Район'
  },
  regions: {
    index: 'Область',
    dialogHeaderText: 'Область',
    country_id: 'Страна',
    region_id: 'Область',
  },
  natioanalities: {
    index: 'Национальность',
    dialogHeaderText: 'Национальность',
    name_uz_latin: 'Узбекская латынь',
  },
  organization: {
    index: 'Организация',
    newOrganization: 'Добавить новую организацию',
    updateOrganization: 'Редактировать',
  },
  employeeDocument: {
    index: 'Документы сотрудника',
    tabel: 'Табелный номер :',
    born_date: "Дата рождения :",
    department: "Подразделения :",
    employee_position: 'Должность :',
    series: 'Серии',
    number: 'Число',
    given_by: 'Кем выдан',
    date_issue: 'Дата выпуска',
    valid_until: 'Срок годности',
    status: 'Статус',
    actions: 'Действия',
    addEmployeeDocument: "Добавить новые документы",
    updateEmployeeDocument: 'Редактировать',
    docType: 'Тип документа',
    title: 'Название документа',
    files: 'Файлы',
    uploadFiles: 'Загрузить файлы',
  },
  employee: {
    index: 'Сотрудники',
    deletedIndex: 'Уволенные сотрудники',
    name: 'Сотрудник',
    Company: 'Организация',
    company_id: 'Организация',
    country_id: 'Страна',
    Nationality: 'Национальность',
    nationality_id: 'Национальность',
    region_id: 'Область',
    district_id: 'Район',
    address: 'Адрес',
    tabel: 'Табелный номер',
    firstname_uz_latin: 'Имя (латин)',
    lastname_uz_latin: 'Фамилия (латин)',
    middlename_uz_latin: 'Отчество (латин)',
    firstname_uz_cyril: 'Имя (кирилл.)',
    lastname_uz_cyril: 'Фамилия (кирилл.)',
    middlename_uz_cyril: 'отчество (кирилл.)',
    firstname: 'Имя',
    lastname: 'Фамилия',
    middlename: 'Отчество',
    born_date: 'Дата рождения',
    INN: 'ИНН',
    INPS: 'ИНПС',
    filter: 'Поиск',
    born_date_from: 'с (дата рождения)',
    born_date_to: 'по (дата рождения)',
    department_id: 'Подразделения',
    category: 'Категория',
    shifr: 'Шифр',
    contract_number: 'Номер контракта',
    contract_date: 'Дата контракта',
    position: 'Должность',
    main_staff: 'Основной штат',
    loaded_staff: 'В загруженном состоянии',
    contractDate: 'Дата контракта',
    contractNumber: 'Номер контракта',
    enterOrderDate: 'Дата Приказ',
    enterOrderNumber: 'Номер Приказ',
    coefficients: 'Надбавка',
    all: 'Всего',
    enter_order_date: 'Дата приказа',
    enter_order_number: 'Номер приказа',
    percent: 'Процент',
    description: 'Описание',
    status: 'Статус',
    begin_date: 'Дата начала',
    end_date: 'Дата окончания',
    active: 'Активный',
    inactive: 'Неактивный',
    addresses: 'Адреса',
    country: 'Страна',
    region: 'Область',
    district: 'Район',
    street_address: 'Адрес улица',
    street_address_uz_latin: 'Адрес улица Л',
    street_address_uz_cyril: 'Адрес улица К',
    street_address_ru: 'Адрес улица Р',
    home_address: 'Домашний адрес',
    home_address_uz_latin: 'Домашний адрес',
    home_address_uz_cyril: 'Домашний адрес',
    home_address_ru: 'Домашний адрес',
    staff_id: 'Штат',
    tariff_scale_id: 'Тарифная сетка',
    first_work_date: 'Дата приема на работу',
    leave_order_number: 'Номер приказа увольнения',
    leave_order_date: 'Дата приказа увольнения',
    newEmployeeStaff: 'Прием на работу',
    editEmployee: 'Редактировать',
    is_main_staff: 'Основной штат',
    employee_staff: "Штаты",
    range: 'Разряд',
    editEmployeeStaff: 'Редактировать штат сотрудника',
    editemployeeCoefficient: 'Редактировать надбавки сотрудника',
    editEmployeeAddress: 'Редактировать адрес сотрудника',
    newEmployeeCoefficient: 'Создать надбавки сотрудника',
    address_type_id: 'Тип адрес',
    order_date: 'Дата приказа',
    newEmployeeAddress: 'Создать адрес сотрудника',
    personalInformation: 'Личные данные',
    education: 'Образование, квалификация',
    spravka: 'Справки',
    family: 'Семя',
    work_exprience: 'Трудовая деятелность',
    hr: 'Кадровые документы',
    military: 'Воинский учет',
    taxes: 'Налог на доходы',
    fullname: 'Ф.И.О.',
    info: 'Сотрудник',
    new_employee: 'Новый сотрудник',
    birth_address: "Адрес рождения",
    residence_address: "Адрес проживания",
    employee_phones: 'Телефоны сотрудников',
    phones: 'Телефоны',
    phone: 'Телефон',
    phone_type: 'Тип телефона',
    phone_number: 'Номер телефона',
    add_new_phone: 'Добавить новый телефон',
    dismissal: 'Увольнение',
    leave_date: 'Дата увольнения',
    leave_order_date: 'Дата приказа',
    leave_order_number: 'Номер приказа',
    leaving_reason_id: 'Причина увольнения',
    info: 'Информация о сотрудниках'
  },
  signerGroup: {
    signer_group_id: 'Группа подписантов',
    new_signer_group: 'Создать группа подписантов',
    edit_signer_group: 'Редактировать группа подписантов',
    staff_list: 'Список штатов',
    add_signer: 'Добавить подписывающего',
  },
  documentTemplates: {
    signers: 'Штаты подписавших',
    index: 'Шаблоны документов',
    sequence: 'Последовательность',
    attribute_name_uz_latin: 'Наименование аттрибута (узб латин)',
    attribute_name_uz_cyril: 'Наименование аттрибута (узб кирил)',
    attribute_name_ru: 'Наименование аттрибута (русский)',
    data_type_id: 'Тип дата',
    value_min_length: 'Мин. длина значения',
    value_max_length: 'Макс. длина значения',
    description: 'Описание',
    attributeName: 'Имя атрибута',
    sign_type: 'Тип подписи',
    registry_type: 'Реестры',
    due_day_count: 'Срок'

  },
  document_detail_attributes: {
    index: 'Атрибуты',
  },
  document_detail_templates: {
    index: 'Детали',
    content: 'Содержание',
    attribute_name_uz_latin: 'Наименование аттрибута (узб латин)',
    attribute_name_uz_cyril: 'Наименование аттрибута (узб кирил)',
    attribute_name_ru: 'Наименование аттрибута (русский)',
    data_type_id: 'Тип дата',
    value_max_length: 'Мин. длина значения',
    value_min_length: 'Макс. длина значения',
    description: 'Описание',
    content_uz_latin: "Композиция узбекская латынь",
    content_uz_cyril: "Композиция Узбек Кирилл",
    content_ru: "Ингредиенты Русские",
    is_list_vertical: "Список вертикальный?",
    is_registry_show: "Реестр показывает?",
    is_show: "Показывает?",
  },
  actionTypes: {
    index: 'Типы действий',
    sequence: 'Последовательность',
  },
  requirementType: {
    index: 'Типы требование',
    create: 'Добавить новый тип',
    edit: 'Редактировать',
    dialogHeaderText: 'Типы требование',
  },
  requirement: {
    index: 'Требования к должности',
    type: 'Тип требования',
    dialogHeaderText: 'Требования к должности',
    requirement_type_id: 'Тип требование',
    newrequirement: 'Создать требования',
    updaterequirement: 'Редактировать требования',
  },
  appeal_content: {
    index: 'Содержание жалобы',
    create: 'Янги қўшиш',
    edit: 'Редактировать',
    dialogHeaderText: 'Содержание жалобы'
  },
  object_type: {
    index: 'Типы объекта',
    create: 'Добавить новый объект',
    edit: 'Редактировать',
    dialogHeaderText: 'Добавить новый объект'
  },
  purchase_catalogs: {
    catalogs: 'Торговые каталоги',
    add_catalog: 'Добавить продукт (сервис)',
    edit_catalog: 'Редактирование продукт (сервис)',
    code: 'Код',
    part_number: 'Номер детали',
    description: 'Описание',
    material_content: 'Материальное содержание',
    name_eng: 'Название на английском языке',
    name_ru: 'Название на русском языке',
    specification: 'Спецификация',
    short_name: 'Краткое имя',
    using_location: 'Использование местоположения',
    using_purpose: 'Целевое использование',
    measure: 'Ед.изм.',
    manufacturer: 'Производитель',
  },
  reasons: {
    index: 'Причины увольнения',
    newReasons: 'Укажите причины увольнения',
    updateReasons: 'Редактировать причины увольнения',

  },
  dismissed: {
    employee: 'Уволенные сотрудники',
  },
  partners: {
    index: 'Поставщики',
    name: 'Название поставщика',
    adress: 'Адрес поставщика',
    bank_name: 'Название банка поставщика',
    bank_adress: 'Адрес банка поставщика',
    account: 'Рассчётный счёт поставщика',
    swift_code: 'SWIFT код',
    inn: 'Номер ИНН',
    mfo: 'МФО',

    add_partners: 'Добавить нового партнера',
    edit: 'Редактировать'
  },
  report: {
    create_document: "Созданные документы",
    expired: 'Просроченные',
    prosesing: ' В процессе',
    waiting: ' В ожидании',
    completed_on_time: 'Завершено вовремя',
    failed_in_time: 'Не завершено вовремя',
  },

  currency: {
    index: 'Валюты',
    title: 'Виды валют',
    name: 'Название',
    code: 'Код',
    description: 'Описание',
    add: 'Добавить новый тип валюты',
    edit: 'Редактировать',
    delete: 'Вы действительно хотите удалить этот тип валюты?',
    history: 'История валюты',
    price: 'Курс',
    date: 'Дата',
    search: 'Поиск',
    oper: 'Операции',
  },
  notification: {
    index: 'Уведомления',
    content: 'Содержание',
    is_active: 'Статус',
    create: 'Добавить новое уведомление',
    edit: 'Редактировать',
    delete: 'Вы действительно хотите удалить это уведомление?',
  },
  accessDepartment: {
    index: 'Доступ к отделам',
    employee: 'Сотрудники',
    department: 'Подразделения',
    access: 'Доступи',
    accessType: 'Тип доступа',
    create: 'Добавить новый доступ',
    tabel: 'Табелный номер',
  },
  accessType: {
    index: 'Типы доступа',
    create: 'Добавить новый тип доступа',
    edit: 'Редактировать',
  },
  registry: {
    index: 'Реестр',
    vacation: 'Реестр приказ отпуск',
    business_trip: 'Реестр приказ командировка',
    work_calendar: 'Рабочий календар',
  },
  carPurchase: {
    ERI: 'Получить электронную подпись',
    index: 'Заявка на покупку автомобиля',
    view: 'Заявка на автомобиль',
    employee: 'Сотрудник',
    carModel: 'Модель автомобиля',
    comment: 'Комментарий',
    status: 'Статус',
    regStatus: 'Статус реестра',
    accEmployee: 'Бухгалтер',
    employeeId: 'Сотрудник',
    file: 'Файл',
    files: 'Файлы',
    create: 'Новая заявка',
    createdBy: 'Создан',
    createdAt: 'Дата',
    department: 'Подразделения',
    position: 'Должность',
    edit: 'Редактировать',
  },
  company_requisites: {
    name_uz_latin: 'Название узбекская латынь',
    name_uz_cyril: 'Название узбекская кириллица',
    name_ru: 'Название русский',
    name: 'Наименование',
    address_name_uz_latin: 'Адрес узбекская латынь',
    address_name_uz_cyril: 'Адрес узбекская кириллица',
    address_name_ru: 'Адрес русский',
    address: 'Адрес',
    inn: 'Номер ИНН',
    account: 'Расчетный счет',
    swift: 'SWIFT код',
    oknh: 'ОКНХ код',
    mfo: 'МФО',
    add_requisites: 'Добавить новый реквизит',
    edit: 'Редактировать',
    delete: 'Удалить',
  },
  reportDepartment: {
    all: 'Все',
    published: 'Опубликованный',
    processing: 'Обработка',
    signed: 'Подписанный',
    ready: 'Готовый',
    completed: 'Завершенный',
    cancelled: 'Отмененный',
    of_them: 'Из них',
    done: 'Выполнено',
    of_them_completed: 'Из них выполнено',
    result: 'Результат',
    on_performance: 'на исполнении',
    for_execution: 'к исполнению',
    overdue: 'Просроченный',
    on_time: 'в срок',
    out_of_date: 'с нарушением срока',
    clarified: 'Даны разъяснения',
    satisfied: 'Удовлетворено:',
    up_to_1_day: 'до 1 дня',
    up_to_2_3_days: 'до 2-3 дней',
    more_than_3_days: 'более 3 дней',
  },
  familyRelatives: {
    index: 'Семья родственники',
    status: 'Статус',
    add: 'Добавить семью родственников',

  },
  inventory: {
    index: 'Inventarizatsiya',
    warehouse: 'Ombor',
    comission: 'Komissiya',
    blank_number: 'Blanka raqami',
    part_number: 'Part NO',
    product_name: 'Masxulot nomi',
    real_stock: 'Sanoq',
    address: 'Adres',
    addressName: 'Adres nomi',
    delete: 'Siz ushbu adresni o\'chirishga aminmisiz?',
    product: 'Maxsulotlar ro\'yxati',
    partNumber: 'Detal raqami',
    productName: 'Maxsulot nomi',
    stock: 'Qoldiq',
    unitMeasure: 'O\'lchov birligi',
    report: 'Hisobot',
    commission: 'Komissiya',
    blank: 'Blankalar'
  },
  directory: {
    index: 'Журналы',
    type: 'Тип журнала',
  }
}
module.exports = ru
